import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Provider } from 'react-redux';
import { store } from './store';
import TraceKit from 'tracekit';
import { setupAxios, setupDayJS, setupGrafanaFaro } from './LibrarySetup';
import { createRoot } from 'react-dom/client';
import { createHashRouter, Navigate, RouterProvider } from "react-router-dom";
import AppRoot from './containers/App';
import ErrorPage from './routes/ErrorPage';
import LoginPage from './routes/login/LoginPage';
import ForgotPasswordPage from './routes/forgotPassword/ForgotPassword';
import PasswordResetPage from './routes/passwordReset/PasswordReset';
import RegisterPage from './routes/register/RegisterPage';
import RegistrationExistsPage from './routes/registrationExists/RegistrationExistsPage';
import MultiFactorSetupPage from './routes/multiFactor/setup/MultiFactorSetupPage';
import MultiFactorEditPage from './routes/multiFactor/edit/MultiFactorEditPage';
import AppDispatch from './routes/app/AppDispatch';
import NotFound404Page from './routes/404/components/404';
import { withFaroRouterInstrumentation } from "@grafana/faro-react";
// setupStackTraceJS()
// setupTraceKit();
setupGrafanaFaro();
setupAxios();
setupDayJS();
const router = createHashRouter([
    {
        path: '/',
        element: _jsx(AppRoot, {}),
        errorElement: _jsx(ErrorPage, {}),
        children: [
            { path: '/', element: _jsx(Navigate, { to: "/app/home", replace: true }) },
            // {path: '/*', element: <AppRoutes/>},
            { path: 'app/*', element: _jsx(AppDispatch, {}) },
            { path: 'login', element: _jsx(LoginPage, {}) },
            { path: 'forgot-password', element: _jsx(ForgotPasswordPage, {}) },
            { path: 'password-reset/:token', element: _jsx(PasswordResetPage, {}) },
            { path: 'register/:channel', element: _jsx(RegisterPage, {}) },
            { path: 'registration-exists', element: _jsx(RegistrationExistsPage, {}) },
            { path: 'multi-factor/setup', element: _jsx(MultiFactorSetupPage, {}) },
            { path: 'multi-factor/edit', element: _jsx(MultiFactorEditPage, {}) },
            { path: '*', element: _jsx(NotFound404Page, {}) }
        ],
    }
]);
const instrumentedRouter = withFaroRouterInstrumentation(router);
try {
    const container = document.getElementById('app-container');
    const root = createRoot(container);
    root.render(_jsx(Provider, { store: store, children: _jsx(RouterProvider, { router: instrumentedRouter }) }));
}
catch (e) {
    if (e instanceof Error) {
        TraceKit.report(e); //error with stack trace gets normalized and sent to subscriber
    }
    throw e;
}
